"use client"

import Link from 'next/link';
import HomeIcon from './icons/home-icon';
import FarmIcon from './icons/farm-icon';
import FriendsIcon from './icons/friends-icon';
import QuestIcon from './icons/quest-icon';
import RoadmapIcon from './icons/roadmap-icon';
import { usePathname } from 'next/navigation';


export default function Footer() {
  const currentPath = usePathname();
  return (
    
    <footer className="fixed bottom-0 z-[2] w-full bg-background text-white pb-3">
      {currentPath != '/' &&
      <nav className="flex justify-around py-2">
        <Link href="/home" className={`flex flex-col items-center pt-0 pb-0 px-3 rounded-xl tabIcon ${currentPath === '/home' ? 'activeTab' : ''}`}>
          <HomeIcon className="w-8 h-8" />
          <span className="text-xs pb-1">Home</span>
        </Link>

        <Link href="/farm" className={`flex flex-col items-center pt-0 pb-0 px-3 rounded-xl tabIcon ${currentPath === '/farm' ? 'activeTab' : ''}`}>
          <FarmIcon className="w-6 h-8" />
          <span className="text-xs pb-1">Farm</span>
        </Link>

        <Link href="/friends" className={`flex flex-col items-center pt-0 pb-0 px-3 rounded-xl tabIcon ${currentPath === '/friends' ? 'activeTab' : ''}`}>
          <FriendsIcon className="w-8 h-8" />
          <span className="text-xs pb-1">Friends</span>
        </Link>

        <Link href="/quest" className={`flex flex-col items-center pt-0 pb-0 px-3 rounded-xl tabIcon ${currentPath === '/quest' ? 'activeTab' : ''}`}>
          <QuestIcon className="w-6 h-7" />
          <span className="text-xs pb-1">Quest</span>
        </Link>

        <Link href="/roadmap" className={`flex flex-col items-center pt-0 pb-0 px-3 rounded-xl tabIcon ${currentPath === '/roadmap' ? 'activeTab' : ''}`}>
          <RoadmapIcon className="w-6 h-6 my-1" />
          <span className="text-xs pb-1">Roadmap</span>
        </Link>
        </nav>
      }
    </footer>
   
  );
}